import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrListTermsPathParameters } from 'api/actions/hr-list-terms/hr-list-terms-path-parameters';
import { HrListTermsResponse } from 'api/actions/hr-list-terms/hr-list-terms-response';

type HrListTermsQueryParameters = Record<string, any>;

/**
 * The path of the HrListTerms action.
 */
export const hrListTermsActionPath = new SweetPath<keyof HrListTermsPathParameters>('/api/hr/terms', {
  path: '{param}',
});

/**
 * Creates a contextualized HrListTerms actions.
 */
export default function createHrListTermsAction(axios: AxiosInstance) {
  return function hrListTermsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HrListTermsQueryParameters } = {}) {
    const path = hrListTermsActionPath.original;

    return axios.request<HrListTermsResponse, HrListTermsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
